<script>
import Select from '@/components/Select';

export default {
  name: 'DynamicInput',
  components: { Select },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    attr: {
      type: Object,
      default: () => {},
    },
    index: {
      type: [Number, String],
      default: null,
    },
  },
  render (createElement) {
    const vm = this;
    const propsData = Object.assign(vm.attr.props, { value: vm.value, index: vm.index });
    propsData.index = propsData.index === null ? '' : propsData.index;
    return createElement(
      vm.attr.inputType,
      {
        props: propsData,
        domProps: {
          value: vm.value,
        },
        attrs: {
          ...this.$attrs,
          name: propsData.name + propsData.index,
          'data-vv-name': propsData.name + propsData.index,
          'data-vv-as': vm.attr.name,
          disabled: propsData.disabled,
          autocomplete: 'off',
        },
        on: {
          input: (event) => {
            if (vm.attr.inputType === 'input') {
              vm.$emit('input', event.target.value);
            } else {
              vm.$emit('input', event);
            }
          },
        },
      },
    );
  },
};
</script>
